import styled from 'styled-components';

export const StyledSectionContent = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  color: #fff;
  flex-direction: column;
  max-width: 500px;
  opacity: ${(props) => (props.visible ? '1' : '0')};
  padding: 20px 27px 30px 27px;
  text-align: center;
  transition: all 600ms ease-in-out;
  transform: ${(props) =>
    props.visible ? 'translateY(0)' : 'translateY(30px)'};
  width: 100%;
  z-index: 2;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    max-width: 500px;
    width: 100%;
  }
  @media (min-width: 800px), (min-device-width: 768px) {
    align-items: flex-start;
    margin-bottom: 80px;
    padding: 20px;
    text-align: left;
  }
  @media (min-width: 1200px) {
    padding-left: 60px;

    &.land-it {
      align-items: flex-start;
      margin: 0 0 80px;
      padding: 20px;
      text-align: left;
    }
  }
`;
